import { render, staticRenderFns } from "./VenetacucineLogo.vue?vue&type=template&id=23a971da&scoped=true&"
var script = {}
import style0 from "./VenetacucineLogo.vue?vue&type=style&index=0&id=23a971da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a971da",
  null
  
)

export default component.exports